import React, { useEffect, useState } from 'react'
import Content from 'blocks.app/content/content'
import CustomList from 'blocks.app/customList/customList'
import Link from 'blocks.simple/link/link'
import translate from 'core/translate'
import { Steps } from 'atoms/Steps/Steps-view'
import { useLocation } from 'react-router'
import { getURLSearchParamsByLocation, getURLSearchParamsString } from 'features/routes/utils'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import styles from './instancesCatalog_drinks.jcss'
import { DRINKS_CATALOG_TITLE_KEY, DrinksSelectedItems, DrinksSliderProducts } from './InstancesCatalogDrinks-types'

const categories = ['sliderProducts', 'menuProducts'] as const
const customListTypes = {
    sliderProducts: 'drinksSlider',
    menuProducts: 'drinksMenu',
} as const

const InstancesCatalogDrinksComponent = () => {
    const location = useLocation()
    const category =
        categories.find((item) => item === getURLSearchParamsByLocation(location).category) || 'sliderProducts'
    const [selectedItems, setSelectedItems] = useState<DrinksSelectedItems>([])
    const [sliderProducts, setSliderProducts] = useState<DrinksSliderProducts>([])

    useEffect(() => {
        setSelectedItems([])
    }, [category])

    return (
        <Content title={DRINKS_CATALOG_TITLE_KEY}>
            <div className={styles.wrapper}>
                <Steps className={styles.tabs} active={category}>
                    {categories.map((item) => (
                        <Link
                            id={item}
                            key={item}
                            to={{
                                pathname: location.pathname,
                                search: getURLSearchParamsString({ category: item }),
                            }}
                        >
                            {translate(item)}
                        </Link>
                    ))}
                </Steps>
                <CustomList
                    key={category}
                    type={customListTypes[category]}
                    onSelect={setSelectedItems}
                    selectedItems={selectedItems}
                    additionalData={{ sliderProducts }}
                    onGetData={(drinksData: { categories: { sliderProducts: DrinksSliderProducts } }) => {
                        setSliderProducts(drinksData.categories.sliderProducts)
                    }}
                />
            </div>
        </Content>
    )
}

export const InstancesCatalogDrinks = checkAvailableModule('instancesCatalog/drinks')
    ? InstancesCatalogDrinksComponent
    : null
